<template>
    <el-select ref="selectRef" v-model="inputModel" fit-input-width remote filterable reserve-keyword label="delivery"
        :placeholder="$t('address')" :remote-method="searchMethod" @change="findAddress" :style="styles"
        class="__kfc_orderType_select __kfc_r_7" :class="classes" :suffix-icon="Search">
        <el-option v-for="item in filteredAddresses" :key="item.full_address"
            :label="item.full_address + ' | ' + item.bairnote" :value="item.full_address" />
    </el-select>
</template>

<script>
import Req from '@/utils/Request';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Search } from '@element-plus/icons-vue'
import { useGtm } from '@gtm-support/vue-gtm';

export default {
    props: ['classes', 'styles'],
    setup (props, { emit }) {
        const gtm = useGtm();
        const { type, classes, value, styles } = props;
        const store = useStore();
        const filteredAddresses = ref([]);
        const selectRef = ref(null);
        const deliveryAddress = computed(() => store.getters['address/getDeliveryAddress']);
        const address = ref(deliveryAddress);
        const inputModel = ref(deliveryAddress.value.full_address);

        watch(deliveryAddress, (newdata, olddata) => {
            console.log(deliveryAddress.value, "dada");
            address.value = newdata;
            inputModel.value = newdata.full_address;
        })

        console.log(inputModel.value, "inputModel")
        const findAddress = (value) => {
            checkApartment(filteredAddresses.value.find(x => x.full_address === value))
        }
        const searchMethod = async (query) => {
            if (query !== '') {
                const { data: result } = await Req({ url: '/searchByAddress?address=' + query, hideSuccess: true, method: 'get', type: 3, disableLoader: false })
                filteredAddresses.value = result.data;
            } else {
                filteredAddresses.value = []
            }

        }
        const checkApartment = async (data) => {
            const podkfc = data?.podkfc
            const { data: result } = await Req({ url: '/manager/getOutletNameByPodKfc', body: { podcode: podkfc }, hideSuccess: true })
            if (result.success) {
                gtm.trackEvent({
                    event: 'selected_address',
                    action: 'selected',
                    value: data?.full_address
                });
                store.dispatch('address/updateDeliveryAddress', data)
                store.dispatch('address/updateDeliveryOutletName', result.result)
                emit('getAddress', { outlet: result.result, address: data })
            } else {
                inputModel.value = address.value.full_address
                // selectedAddress.value = deliveryAddress.value;
            }
        }
        return {
            inputModel, address, selectRef, searchMethod, findAddress, filteredAddresses, classes, styles, Search
        }
    }
}
</script>

<style></style>